import React, { Fragment, useState, useEffect, useContext } from "react";
import { Grid, Container, Typography, Button, Box } from "@material-ui/core";
import BreadCrumbs from "../../components/BreadCrumbs";
import { ThemeContext } from "../../context/ThemeContext";
import { AuthContext } from "../../auth/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { httpGet } from "../../lib/apiClients";
import { AxiosResponse } from "axios";
import SaleTicketList from "../../components/support/menu/SaleTicketList";
import LoaderComponent from "../../components/LoaderComponent";
import ToastModal from "../../components/ToastModal";
import MenuModal from "../../components/MenuModal";
import { Environment } from "../../utils/environments";
import { UserDataContext } from "../../context/UserDataContext";
import UserFreeTicket from "../../components/UserFreeTicket";
import InterviewTicket from "../../components/InterviewTicket";
import BreadCrumbLinks from "../../components/BreadCrumbLinks";
import useFetchSaleTickets from "../../hooks/useFetchSaleTickets";
export default function Menu() {
  const { getMenuListData } = useContext(ThemeContext);
  const [menuListData, setMenuListData] = getMenuListData;
  const { currentUser } = useContext(AuthContext);
  const [menuModal, setMenuModal] = useState<boolean | []>(false);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  // const [isFirstTime, setIsFirstTime] = useState<boolean>(false);
  const { isTicketFree } = useContext(UserDataContext);
  // const [userFreeTicket, setUserFreeTicket] = useState<[] | undefined>(
  //   undefined
  // );
  const { saleTickets, fetchSaleTickets } = useFetchSaleTickets();
  const [minutesSupport, setMinutesSupport] = useState<string | undefined>(
    undefined
  );
  const [currentMenuList, setCurrentMenuList] = useState<[] | undefined>(
    undefined
  );

  const [ticketsToShow, setTicketsToShow] = useState<any>(undefined);

  const navigate = useNavigate();
  const { state } = useLocation();
  useEffect(() => {
    document.title = "メニュー選択 | じぶん専用IT相談室";
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", { state: { from: window.location.pathname } });
      return;
    }
    if (!saleTickets) {
      fetchSaleTickets();
    } else {
      const filteredTickets = saleTickets.filter(
        (ticket: any) => ticket.showOnMypage === true
      );
      setTicketsToShow(filteredTickets);
    }
    if (state && state.displayToast == true) {
      setErrorModal(true);
    }
  }, [currentUser, saleTickets]);

  /**
   * Get the menu list for different support options
   */
  const getMenuList = async (minutesToSupport) => {
    var obj = {};
    try {
      const response: AxiosResponse<any> = await httpGet({
        pathName: "reservation-menu-list",
        queryParams: { estimatedMinute: minutesToSupport },
      });
      const data = response.data;
      if (Environment.getBuildType() != "prod") {
        console.log(data);
      }
      obj[`minutesToSupport`] = minutesToSupport;
      obj[`${minutesToSupport}minutesData`] = data.reservationMenuList;
      setCurrentMenuList(data.reservationMenuList);
      setMenuListData((prevState) => {
        return { minutesToSupport: minutesToSupport, ...prevState, ...obj };
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.error("Error fetching menu list:", error);
      }
      navigate(`/error?code=${error.response?.status}`);
    }
  };
  useEffect(() => {
    if (Environment.getBuildType() != "prod") {
      console.log(menuListData);
    }
  }, [menuListData]);
  // useEffect(() => {
  //   if (firstUserData) {
  //     setUserFreeTicket(firstUserData.userHasFreeTicket);
  //     setIsFirstTime(firstUserData.isFirstTimeUser);
  //   }
  // }, [firstUserData]);

  /**
   * Submit the selected menu and navigate to the staff page
   */
  function submitMenu(ticket) {
    navigate(`/support/staff?productId=${ticket.productId}`, {
      state: { ticket },
    });
  }
  function openMenuModal(minutesToSupport) {
    setCurrentMenuList(undefined);
    if (Environment.getBuildType() != "prod") {
      console.log(minutesToSupport);
    }
    setMinutesSupport(undefined);
    if (menuListData) {
      if (!menuListData[`${minutesToSupport}minutesData`]) {
        getMenuList(minutesToSupport);
      } else {
        setCurrentMenuList(menuListData[`${minutesToSupport}minutesData`]);
        if (Environment.getBuildType() != "prod") {
          console.log(menuListData);
        }
      }
    } else {
      getMenuList(minutesToSupport);
    }
    setMinutesSupport(minutesToSupport);
    setMenuModal(true);
  }

  return (
    <Fragment>
      <BreadCrumbLinks currentPage={"チケットを選ぶ"} />
      <Box className="section menu-page bg-dots">
        <BreadCrumbs currentPage={"チケットを選ぶ"} preHeading="Menu" />
        {ticketsToShow ? (
          <Fragment>
            <Container className="container">
              <Typography
                component="h6"
                variant="h6"
                style={{
                  fontWeight: 600,
                  marginBottom: "1.5rem",
                  textAlign: "center",
                }}
              >
                お悩みは、以下のチケットからご選択ください。
                <br />
                各チケットでサポートできるお悩みの例を知りたい方は、解決できるお悩みの例を参考にしてください。
                <br />
                目安時間経過後も継続してサポートをご希望の場合は、延長チケットをご購入いただけます。
              </Typography>
              <SaleTicketList
                saleTickets={ticketsToShow}
                openMenuModal={openMenuModal}
                submitMenu={submitMenu}
              />
              {errorModal && (
                <ToastModal
                  errorModal={errorModal}
                  setErrorModal={setErrorModal}
                  message={"メニューを選択してください"}
                />
              )}
            </Container>
            {/* {userFreeTicket && isFirstTime ? (
              <Box component={"section"} className="section">
                <Container className="container">
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                    direction="column"
                  >
                    <Grid item md={6} sm={12} xs={12}>
                      <Typography
                        style={{ marginBottom: "30px", textAlign: "center" }}
                      >
                        トラブルの原因が分からない方やどうしていいか分からない方は、
                        無料問診をご利用ください。相談員に電話で無料相談できます。
                      </Typography>
                    </Grid>
                    <UserFreeTicket ticketList={userFreeTicket} />
                  </Grid>
                </Container>
              </Box>
            ) : (
              <Box component={"section"} className="section">
                <Container className="container">
                  <Grid container justifyContent="center">
                    <InterviewTicket />
                  </Grid>
                </Container>
              </Box>
            )} */}

            {/* <Box component={"section"} className="section">
              <Container className="container">
                <Grid
                  container
                  alignItems="center"
                  justifyContent="center"
                  direction="column"
                >
                  <Grid item md={6} sm={12} xs={12}>
                    <Typography
                      style={{ marginBottom: "30px", textAlign: "center" }}
                    >
                      トラブルの原因が分からない方やどうしていいか分からない方は、
                      無料問診をご利用ください。相談員に電話で無料相談できます。
                    </Typography>
                  </Grid>
                  <UserFreeTicket />
                </Grid>
              </Container>
            </Box>
            <div className="text-center mt-20">
              <button
                className="secondary-btn"
                onClick={() => {
                  navigate("/");
                }}
              >
                ホームに戻る
              </button>
            </div> */}
            <Box component={"section"} className="section">
              <Container className="container">
                <Grid container justifyContent="center">
                  {isTicketFree ? <UserFreeTicket /> : <InterviewTicket />}
                </Grid>
              </Container>
            </Box>
          </Fragment>
        ) : (
          <LoaderComponent />
        )}
        {menuModal && (
          <MenuModal
            menuModal={menuModal}
            setMenuModal={setMenuModal}
            minutesSupport={minutesSupport}
            currentMenuList={currentMenuList}
            key={minutesSupport && minutesSupport}
          />
        )}
      </Box>
    </Fragment>
  );
}
